//updatePosting api error list
export const postingNonIgnorableErrorList = [
  'AUCTION_ITEM_NOT_FOUND',
  'MISSING_MANDATORY_ATTRIBUTES',
  'INVALID_VEHICLE_TYPE',
  'INVALID_STOCK_NUMBER',
  'INVALID_ODOMETER',
  'INVALID_STORAGE_LOCATION',
  'INVALID_INTRANSIT_DATE',
  'INVALID_TIRE_INFORMATION',
  'INTRANSIT_DATE_EXCEED_THRESHOLD',
  'INTRANSIT_DATE_LESS_THAN_POSTING_DATE',
  'OPENING_PRICE_LESS_THAN_THRESHOLD',
  'OPENING_PRICE_GREATER_THAN_BUY_NOW',
  'REMAINING_AUCTION_DAYS_ZERO',
  'CROSSED_EDIT_CUT_OFF_TIME',
  'VEHICLE_NOT_ELIGIBLE_FOR_EDIT',
  'AUCTION_COMMENT_INVALID',
  'DISCLOSURE_COMMENT_INVALID',
  'MODIFIED_AFTER_LAST_READ',
  'GENERAL_ERROR',
  'INVALID_EXTERIOR_COLOR',
  'INVALID_INTERIOR_COLOR',
  'UNAUTHORIZED',
  'DISCLOSURE_COMMENT_EXCEEDS_LIMIT',
  'INVALID_TITLE_STATE',
  'NOT_AFTER_MARKET_OPTION',
  'INVALID_STORAGE_LOCATION_ADDRESS',
  'INVALID_MANUFACTURER_MODEL_CODE_ERROR',
  'INSPECTION_VIN_NOT_FOUND',
  'INSPECTION_COMPANY_NOT_FOUND',
  'INSPECTION_DATE_NOT_FOUND',
  'STATUS_DATE_NOT_FOUND',
  'INVALID_INTERIOR_TYPES',
  'INVALID_BASE_PRICE_ERROR',
  'INVALID_OPENING_PRICE_ERROR',
  'INVALID_BUY_NOW_PRICE_ERROR',
  'DEFAULT_SELLER_CREDIT_LINE_LOCKED',
  'DEFAULT_SELLER_CREDIT_LINE_INACTIVE',
  'SELLER_CREDIT_LINE_NOT_AVAILABLE',
  'SELLER_NOT_ELIGIBLE_TO_SELL',
  'SELLER_CONTACT_NOT_FOUND',
  'VEHICLE_OPTIONS_NOT_FOUND',
  'SOLD_VIN_REPOST_DATE_LIMIT_NOT_MET',
  'VEHICLE_ACTIVE_OR_HOLD',
  'AUCTION_RULE_NOT_FOUND',
  'AUCTION_INSTANCE_NOT_FOUND',
  'AUCTION_INSTANCE_NOT_ALLOWED',
  'INVALID_YELLOW_LIGHT',
  'INVALID_PRICE',
  'INVALID_REMAINING_DAYS'
];

export const postingIgnorableErrors = [
  'OPENING_PRICE_DIFFERENCE_EXCEEDS_THRESHOLD',
  'BUYNOW_PRICE_DIFFERENCE_EXCEEDS_THRESHOLD',
  'TRIM_NOT_SELECTED',
  'OFFER_ELIGIBILITY'
];

export const sellerNotEligibleToPostVinForLocation =
  'SELLER_NOT_ELIGIBLE_TO_POST_VIN_FOR_LOCATION';
